import React from 'react'
import Link from 'next/link'
import ExamIcon from "@/images/exam-icon.svg";
import ApplyIcon from "@/images/apply-icon.svg";
import PersonAccessIcon from "@/images/person-access-icon.svg";
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { trackApplyButton } from '@/utils/dataLayer';

const JobGuaranteeSection = () => {
    const { t } = useTranslation();
    const benefits = [
        t("home-page.job-guarantee-benefit-1"),
        t("home-page.job-guarantee-benefit-2"),
        t("home-page.job-guarantee-benefit-3")
    ]

    const processSteps = [
        {
            number: 1,
            icon: ApplyIcon,
            text: t("home-page.job-guarantee-step-1"),
            textLines: 1
        },
        {
            number: 2,
            icon: ExamIcon,
            text: t("home-page.job-guarantee-step-2"),
            textLines: 2
        },
        {
            number: 3,
            icon: PersonAccessIcon,
            text: t("home-page.job-guarantee-step-3"),
            textLines: 1
        }
    ]

    return (
        <div className="pt-[60px] pb-[60px] md:pt-[100px] md:pb-[150px] bg-gradient-to-b from-[#091F59] to-[#1A3884] md:rounded-[64px] rounded-[24px] mb-[100px] md:mb-[200px] mx-[8px]">
            <div className='max-w-[90%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10'>
                <div className='flex flex-col gap-[40px] w-full' >
                    <div>
                        <h2 className='text-[32px] md:text-[48px] lg:text-[64px] font-[500] text-white leading-tight'>{t("home-page.job-guarantee-title-1")}</h2>
                        <h2 className='text-[32px] md:text-[48px] lg:text-[64px] font-[500] text-main-pink leading-tight'>
                            {t("home-page.job-guarantee-title-2")}
                        </h2>
                    </div>
                    <ul className='flex flex-col gap-[10px]'>
                        {benefits.map((benefit, index) => (
                            <li key={index} className='flex items-start gap-3'>
                                <span className='text-white text-[10px] font-bold mt-[7px]'>•</span>
                                <span className='text-white text-[14px] md:text-[16px] lg:text-[18px] font-[400] leading-relaxed my-auto '>{benefit}</span>
                            </li>
                        ))}
                    </ul>
                    <Link href="/apply" onClick={() => trackApplyButton("job_guarantee")}>
                        <button
                            className="w-full md:w-[300px] md:h-[56px] h-[48px] px-8 text-white text-[16px] font-[500] rounded-full transition-all duration-300 cursor-pointer bg-main-pink border border-main-pink hover:!bg-white hover:!text-main-pink"
                        >
                            {t("apply-btn")}
                        </button>
                    </Link>
                </div >
                <div className="flex flex-col items-center justify-center relative w-full ">
                    <div className="flex flex-row items-center justify-center relative w-full md:w-auto">
                        {processSteps.slice(0, 2).map((step, index) => {
                            const IconComponent = step.icon
                            return (
                                <div
                                    key={index}
                                    className="flex flex-col items-center justify-center w-full md:w-auto relative"
                                    style={{
                                        zIndex: 2 - index,
                                    }}
                                >
                                    <div
                                        className={`sm:w-[160px] sm:h-[160px] w-[150px] h-[150px] lg:w-[290px] lg:h-[290px] rounded-full border border-white/40 flex flex-col items-center justify-center bg-transparent relative gap-[8px] ${index > 0 ? '-ml-[15px] lg:-ml-[45px]' : ''
                                            }`}
                                    >
                                        <div
                                            className="lg:w-[80px] lg:h-[80px] w-[48px] h-[48px] rounded-full flex items-center justify-center mt-0 lg:mt-[5px] relative z-10 bg-white"
                                        >
                                            <div className="absolute lg:top-[-10px] lg:right-[-10px] top-[-5px] right-[-5px] lg:w-[40px] lg:h-[40px] w-[22px] h-[22px] bg-main-pink rounded-full flex items-center justify-center">
                                                <span className="text-white text-[10px] lg:text-[16px] font-bold">{step.number}</span>
                                            </div>
                                            <Image src={IconComponent} alt="icon" width={48} height={48} loading="lazy" className=" lg:w-[48px] lg:h-[48px] w-[24px] h-[24px]" />
                                        </div>

                                        <div className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-[400] text-center leading-relaxed px-5">
                                            <span className='lg:text-[22px] text-[12px] font-[600]'>{step.text}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    
                    <div className="flex flex-col items-center justify-center relative w-full md:w-auto -mt-[40px] lg:-mt-[70px]">
                        {processSteps.slice(2).map((step, index) => {
                            const IconComponent = step.icon
                            return (
                                <div
                                    key={index + 2}
                                    className="flex flex-col items-center justify-center w-full md:w-auto relative"
                                    style={{
                                        zIndex: 1,
                                    }}
                                >
                                    <div
                                        className="sm:w-[160px] sm:h-[160px] w-[150px] h-[150px] lg:w-[290px] lg:h-[290px] rounded-full border border-white/40 flex flex-col items-center justify-center bg-transparent relative gap-[8px]"
                                    >
                                        <div
                                            className="lg:w-[80px] lg:h-[80px] w-[48px] h-[48px] rounded-full flex items-center justify-center mt-0 lg:mt-[5px] relative z-10 bg-white"
                                        >
                                            <div className="absolute lg:top-[-10px] lg:right-[-10px] top-[-5px] right-[-5px] lg:w-[40px] lg:h-[40px] w-[22px] h-[22px] bg-main-pink rounded-full flex items-center justify-center">
                                                <span className="text-white text-[10px] lg:text-[16px] font-bold">{step.number}</span>
                                            </div>
                                            <Image src={IconComponent} alt="icon" width={48} height={48} loading="lazy" className=" lg:w-[48px] lg:h-[48px] w-[24px] h-[24px]" />
                                        </div>

                                        <div className="text-white text-[12px] md:text-[14px] lg:text-[16px] font-[400] text-center leading-relaxed px-5">
                                            <span className='lg:text-[22px] text-[12px] font-[600]'>{step.text}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default JobGuaranteeSection
